import { mapState, mapMutations } from "vuex";

export default {
  created() {
    this.$overLabelSelectionArea = false;
    this.$maybeSelectLabel = this.maybeSelectLabel.bind(this);
    document.addEventListener("keyup", this.$maybeSelectLabel);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.$maybeSelectLabel)
  },
  computed: {
    ...mapState("settings", ["labels"]),
  },
  methods: {
    ...mapMutations("settings", [ "selectLabel" ]),
    enterLabelSelectionArea() {
      console.debug("over label selection area");
      this.$overLabelSelectionArea = true;
    },
    leaveLabelSelectionArea() {
      console.debug("out of label selection area");
      this.$overLabelSelectionArea = false;
    },
    maybeSelectLabel() {
      // deprecated since labelSet
      // if (this.$overLabelSelectionArea && !this.$root.$searchFieldHasFocus) {
      //   const path = this.$router.currentRoute.path;
      //   if (path.startsWith("/explore") || path.startsWith("/suggestions") || path.startsWith("/documents")) {
      //     const labelIndex = event.which - 49;
      //     if (labelIndex >= 0 && labelIndex < this.labels.length) {
      //       this.selectLabel(this.labels[labelIndex]);
      //     }
      //   }
      //}
    }
  }
}